import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/lib/utils';

interface DroppableTimeSlotProps {
  id: string;
  dateKey: string;
  hour: number;
  slotHeight: number;
  children: React.ReactNode;
  workingBoundaryMinutes?: number[];
  isOutsideWorkingHours?: boolean;
}

export function DroppableTimeSlot({
  id,
  dateKey,
  hour,
  slotHeight,
  children,
  workingBoundaryMinutes = [],
  isOutsideWorkingHours = false,
}: DroppableTimeSlotProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { type: 'TimeSlot', dateKey, hour, slotHeight },
  });

  return (
    <div
      ref={setNodeRef}
      role="gridcell"
      aria-label={`Time slot at ${hour}:00 on ${dateKey}`}
      className={cn(
        'calendar-slot relative border-r border-t',
        isOutsideWorkingHours && 'bg-muted/20',
        isOver && 'bg-primary/10 ring-primary/50 ring-2'
      )}
      style={{ height: slotHeight }}
    >
      {workingBoundaryMinutes.map(minute => (
        <div
          key={minute}
          aria-hidden="true"
          className="pointer-events-none absolute left-0 right-0 z-10 border-t-2 border-foreground/80"
          style={{ top: `${(minute / 60) * 100}%` }}
        />
      ))}
      {children}
    </div>
  );
}
